import { EssentialsMessageMetadata } from '@lyrahealth-inc/shared-app-logic/src/models/messages/Messages'

import { AvatarDetails } from '../../atoms/icons/Avatar'

export type ProviderFeedback = {
  avatarDetails: AvatarDetails
  feedbackBody: string
  feedbackDateTime: string
}

export enum MessageType {
  DELETED,
  ACTIVITY,
  CHAT_BUBBLE,
  SCHEDULING,
}

export enum MessageAttachmentType {
  DBL = 'DBL',
  PBL = 'PBL',
  ESSENTIALS_LINK = 'ESSENTIALS_LINK',
}

interface BaseMessageAttachmentData {
  type: MessageAttachmentType
  key: string
}

interface DBLMessageAttachmentData extends BaseMessageAttachmentData {
  type: MessageAttachmentType.DBL
}

export interface EssentialsLinkMessageAttachmentData extends BaseMessageAttachmentData {
  type: MessageAttachmentType.ESSENTIALS_LINK
  url: string
}
export interface PBLMessageAttachmentData extends BaseMessageAttachmentData {
  type: MessageAttachmentType.PBL
  program?: string
}
export type MessageAttachmentData =
  | DBLMessageAttachmentData
  | EssentialsLinkMessageAttachmentData
  | PBLMessageAttachmentData

export interface Message {
  messageId: string
  receiver: boolean
  message: string
  avatarDetails?: AvatarDetails
  dateCreated: string
  isLatestMessage: boolean
  sendStatus: 'sent' | 'sending' | 'failed'
  showTime: boolean
  linkText?: string
  activityResponseId?: string
  activityId?: string
  submitDate?: string
  activityTitle?: string
  timeZone?: string
  type: MessageType
  messageType?: string
  authorType?: string
  attachments?: MessageAttachmentData[]
  essentials?: EssentialsMessageMetadata[]
  messageFeedbackValue?: string
  genAiMessageId?: string
  feedbackResponseId?: string
  riskLevel?: string
}
